export default "__VITE_ASSET__TaILmTL$__ 778w";